module.exports = __webpack_public_path__ + "img/116.5b23346a.jpg";